import React from 'react';
import cs from 'classnames';
import { WidgetArrowLeft } from '../../../../../Icons/dist';
import { WidgetFeature } from '../WidgetFeatureList/WidgetFeatureList';
import { WidgetClickedElement } from '../../../../stores/UiLoggerStore';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import styles from './WidgetFeatureHeader.scss';

interface WidgetFeatureHeaderProps extends WithTranslations {
  features: WidgetFeature[];
  selectedFeature: WidgetFeature;
  createSelectFeatureHandler: (
    element: WidgetClickedElement,
    feature: WidgetFeature | null,
    selectedToolIndex?: number,
  ) => (e: React.MouseEvent) => void;
  dataHook?: string;
}

const WidgetFeatureHeaderCmp: React.FC<WidgetFeatureHeaderProps> = ({
  t,
  features,
  selectedFeature,
  createSelectFeatureHandler,
  dataHook,
}) => {
  const onBackButtonClick = createSelectFeatureHandler('Back Button', null);

  return (
    <header className={styles.header} data-hook={dataHook}>
      <span className={styles.back} onClick={onBackButtonClick}>
        <WidgetArrowLeft /> {t('widget.allTools')}
      </span>
      <div className={styles.selector}>
        {features.map((feature, index) => (
          <div
            key={index}
            className={cs(styles.selectorItem, { [styles.active]: feature === selectedFeature })}
            onClick={createSelectFeatureHandler('Tool Pagination', feature, index)}
          >
            <span className={styles.selectorItemLabel}>{index + 1}</span>
          </div>
        ))}
      </div>
    </header>
  );
};

export const WidgetFeatureHeader = withTranslations(WidgetFeatureHeaderCmp);
